import Vue from 'vue';
import {
  titleCase, sentenceCase, formatPrice, stringSeparator, truncateString, percentage, address, leadStatus, placeholderWhenNoData, formatNumber,
} from './string-filters';

Vue.filter('formatPrice', formatPrice);
Vue.filter('titleCase', titleCase);
Vue.filter('sentenceCase', sentenceCase);
Vue.filter('stringSeparator', stringSeparator);
Vue.filter('truncateString', truncateString);
Vue.filter('percentage', percentage);
Vue.filter('address', address);
Vue.filter('leadStatus', leadStatus);
Vue.filter('placeholderWhenNoData', placeholderWhenNoData);
Vue.filter('formatNumber', formatNumber);

Vue.prototype.$filters = Vue.options.filters